export const NODE_API_PREFIX = "/pwa-api"
export const PPMC_API_PREFIX = "/ppmc"

export const GA_EVENT_COMMON = {
    pageViewEventName: "pwaPageViewVirtual",
    eventName: "newGAEvent",
}
export const WIDGET_NAME = {
    LabTestDescription: "lab_test_basic_description",
    RatingsOverview: "rating_widget",
    PanelDetails: "panel_details",
    LabImages: "lab_images",
    HorizontalPackageListing: "horizontal_package_listing",
    PACKAGE_FALLBACK: "url",
    ListOfEditableDetails: "quick_editable_details",
    ListOfFeatures: "list_of_features",
    StillAndMovingImages: "lab_images",
    FootNotes: "foot_notes",
    ListOfTestCarousel: "list_of_tests_horizontal",
    WalkInDetails: "walk_in_details",
}

export const COL_1 = "calc(calc(100vw - 72px) / 6)"
export const COL_2 = `calc(calc(${COL_1} * 2) + 8px)`
export const COL_3 = `calc(calc(${COL_1} * 3) + 16px)`
export const COL_4 = `calc(calc(${COL_1} * 4) + 24px)`
export const COL_5 = `calc(calc(${COL_1} * 5) + 32px)`
export const COL_6 = `calc(calc(${COL_1} * 6) + 40px)`

export const DIAGNOSTICS = "diagnostics"

export const SSE_BASE_ENDPOINT = `${process.env.INTERNAL_NODE_API_URL}${NODE_API_PREFIX}/server-side-event/subscribe`

export const SUPPORTED_VERSIONS_FOR_WEBVIEW_SUPER_PROPERTIES_CALLBACK = {
    android: "18.6.0",
    ios: "18.8.0",
}
